/**
 * Segment tracking event constants
 * Used to standardize event types sent into Segment
 */

/* ------------------- Dynamic Score Reports events ------------------- */

export const EVENT_PLATFORM_LOGIN_BUTTON_CLICK =
  "platform login button clicked";

export const EVENT_DYNAMIC_SCORE_REPORT_VIEW = "viewed";

export const EVENT_PDF_DOWNLOAD = "PDF downloaded";

export const EVENT_EPP_JOB_FAMILY_SELECT = "- EPP job family selected";
